module.exports = __webpack_public_path__ + "static/gallery9-20527d16e97b465d983cb3f46fce5f5b.jpg";